tinymce.addI18n("lv", {
    "#": "#",
    "Accessibility": "Piek\u013c\u016bstam\u012bba",
    "Accordion": "Akordeons",
    "Accordion body...": "Akordeona saturs...",
    "Accordion summary...": "Akordeona kopsavilkums...",
    "Action": "Darb\u012bba",
    "Activity": "Aktivit\u0101tes",
    "Address": "Adrese",
    "Advanced": "Papildus",
    "Align": "L\u012bdzin\u0101t",
    "Align center": "Centr\u0113t",
    "Align left": "Pa kreisi",
    "Align right": "Pa labi",
    "Alignment": "Izl\u012bdzin\u0101\u0161ana",
    "Alignment {0}": "Izl\u012bdzin\u0101jums {0}",
    "All": "Viss",
    "Alternative description": "Alternat\u012bvais apraksts",
    "Alternative source": "Alternat\u012bvs avots",
    "Alternative source URL": "Alternatvais URL avots",
    "Anchor": "Enkurs",
    "Anchor...": "Enkurs...",
    "Anchors": "Saites",
    "Animals and Nature": "Dz\u012bvnieki un daba",
    "Arrows": "Bultas",
    "B": "Z",
    "Background color": "Fona kr\u0101sa",
    "Background color {0}": "Fona kr\u0101sa {0}",
    "Black": "Melns",
    "Block": "Bloks",
    "Block {0}": "Bloks {0}",
    "Blockquote": "Cit\u0101ts",
    "Blocks": "Bloka elementi",
    "Blue": "Zils",
    "Blue component": "Zilais komonents",
    "Body": "Saturs",
    "Bold": "Treknraksts",
    "Border": "Apmale",
    "Border color": "Apmales kr\u0101sa",
    "Border style": "Apmales stils",
    "Border width": "Apmales biezums",
    "Bottom": "Apak\u0161\u0101",
    "Browse files": "P\u0101rl\u016bkot failus",
    "Browse for an image": "Izv\u0113l\u0113ties att\u0113lu",
    "Browse links": "P\u0101rl\u016bkot saites",
    "Bullet list": "Nenumur\u0113ts saraksts",
    "Cancel": "Atcelt",
    "Caption": "Ar virsrakstu",
    "Cell": "\u0160\u016bna",
    "Cell padding": "Iek\u0161\u0113j\u0101 atstarpe",
    "Cell properties": "\u0160\u016bnas parametri",
    "Cell spacing": "\u0160\u016bnu atstarpe",
    "Cell styles": "\u0160\u016bnas stils",
    "Cell type": "\u0160\u016bnas veids",
    "Center": "Centr\u0113t",
    "Characters": "Simboli",
    "Characters (no spaces)": "Simboli (bez atstarpem)",
    "Circle": "Aplis",
    "Class": "Klase",
    "Clear formatting": "No\u0146emt format\u0113jumu",
    "Close": "Aizv\u0113rt",
    "Code": "Kods",
    "Code sample...": "Koda paraugs...",
    "Code view": "Koda skats",
    "Color Picker": "Atlas\u012bt kr\u0101su",
    "Color swatch": "Kr\u0101su paraugs",
    "Cols": "Kolonnas",
    "Column": "Sleja",
    "Column clipboard actions": "Slejas starpliktuves darb\u012bba",
    "Column group": "Sleju grupa",
    "Column header": "Slejas galvene",
    "Constrain proportions": "Saglab\u0101t proporciju",
    "Copy": "Kop\u0113t",
    "Copy column": "Kop\u0113t sleju",
    "Copy row": "Kop\u0113t rindu",
    "Could not find the specified string.": "Mekl\u0113tais teksts netika atrasts.",
    "Could not load emojis": "Nevar\u0113ja iel\u0101d\u0113t emoz\u012bmes",
    "Count": "Skaits",
    "Currency": "Val\u016bta",
    "Current window": "Taj\u0101 pa\u0161\u0101 log\u0101",
    "Custom color": "Specifisk\u0101 kr\u0101sa",
    "Custom...": "Izv\u0113l\u0113ties citu...",
    "Cut": "Izgriezt",
    "Cut column": "Izgriezt sleju",
    "Cut row": "Izgriezt rindu",
    "Dark Blue": "Tum\u0161i zils",
    "Dark Gray": "Tum\u017ei Pel\u0113ks",
    "Dark Green": "Tum\u0161i za\u013ca",
    "Dark Orange": "Tum\u0161i Oran\u017es",
    "Dark Purple": "Tum\u0161i violets",
    "Dark Red": "Tum\u0161i Sarkans",
    "Dark Turquoise": "Tum\u0161s tirk\u012bzs",
    "Dark Yellow": "Tum\u0161i Dzeltens",
    "Dashed": "P\u0101rtraukts",
    "Date/time": "Datums/laiks",
    "Decrease indent": "Samazin\u0101t atk\u0101pi",
    "Default": "Noklus\u0113tais",
    "Delete accordion": "Dz\u0113st akordeonu",
    "Delete column": "Dz\u0113st sleju",
    "Delete row": "Dz\u0113st rindu",
    "Delete table": "Dz\u0113st tabulu",
    "Dimensions": "Izm\u0113rs",
    "Disc": "Disks",
    "Div": "Div",
    "Document": "Dokuments",
    "Dotted": "Punkt\u0113ts",
    "Double": "Dubults",
    "Drop an image here": "Ievelciet att\u0113lu \u0161eit",
    "Dropped file type is not supported": "Nomest\u0101 faila tips netiek atbalst\u012bts",
    "Edit": "Labot",
    "Embed": "Embed kods",
    "Emojis": "Emoz\u012bme",
    "Emojis...": "Emoz\u012bmes...",
    "Error": "K\u013c\u016bda",
    "Error: Form submit field collision.": "K\u013c\u016bda: Formas apstiprin\u0101\u0161anas lauka k\u013c\u016bda.",
    "Error: No form element found.": "K\u013c\u016bda: Formas elements nav atrasts.",
    "Extended Latin": "Papla\u0161in\u0101tie lat\u012b\u0146u",
    "Failed to initialize plugin: {0}": "Neizdev\u0101s iel\u0101d\u0113t spraudni: {0}",
    "Failed to load plugin url: {0}": "K\u0101du spraudni neizdev\u0101s iel\u0101d\u0113t. Avots: {0}",
    "Failed to load plugin: {0} from url {1}": 'Spraudni "{0}" neizdev\u0101s iel\u0101d\u0113t. Avots: {1}',
    "Failed to upload image: {0}": "Att\u0113la aug\u0161upiel\u0101de neizdev\u0101s: {0}",
    "File": "Datne",
    "Find": "Mekl\u0113t",
    "Find (if searchreplace plugin activated)": 'Atrast (Ja "searchreplace" spraudnis ir akt\u012bvs)',
    "Find and Replace": "Mekl\u0113t un Aizst\u0101t",
    "Find and replace...": "Mekl\u0113t un aizvietot...",
    "Find in selection": "Atrast izv\u0113l\u0113taj\u0101",
    "Find whole words only": "Mekl\u0113t k\u0101 pilnu v\u0101rdu",
    "Flags": "Karogi",
    "Focus to contextual toolbar": "Fokuss uz papildizv\u0113lni",
    "Focus to element path": "Fokuss uz elementa ce\u013cu",
    "Focus to menubar": "Fokuss uz izv\u0113lni",
    "Focus to toolbar": "Fokuss uz r\u012bkjoslu",
    "Font": "Fonts",
    "Font size {0}": "Fonta lielums {0}",
    "Font sizes": "Fonta lielums",
    "Font {0}": "Fonts {0}",
    "Fonts": "Fonti",
    "Food and Drink": "\u0112dieni un Dz\u0113rieni",
    "Footer": "K\u0101jene",
    "Format": "Format\u0113t",
    "Format {0}": "Form\u0101ts {0}",
    "Formats": "Format\u0113jumi",
    "Fullscreen": "Pilnekr\u0101na re\u017e\u012bms",
    "G": "G",
    "General": "Pamata info",
    "Gray": "Pel\u0113ks",
    "Green": "Za\u013c\u0161",
    "Green component": "Za\u013cais komonents",
    "Groove": "Grope",
    "Handy Shortcuts": "Paroc\u012bgi \u012bsce\u013ci",
    "Header": "Galvene",
    "Header cell": "Galvenes \u0161\u016bna",
    "Heading 1": "Virsraksts 1",
    "Heading 2": "Virsraksts 2",
    "Heading 3": "Virsraksts 3",
    "Heading 4": "Virsraksts 4",
    "Heading 5": "Virsraksts 5",
    "Heading 6": "Virsraksts 6",
    "Headings": "Virsraksti",
    "Height": "Augstums",
    "Help": "Pal\u012bdz\u012bba",
    "Hex color code": "Hex kr\u0101sas kods",
    "Hidden": "Sl\u0113pts",
    "Horizontal align": "Horizontala izl\u012bdzin\u0101\u0161ana",
    "Horizontal line": "Horizont\u0101l\u0101 l\u012bnija",
    "Horizontal space": "Horizont\u0101l\u0101 atstarpe",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID j\u0101s\u0101kas ar burtu, kam seko tikai burti, cipari, domuz\u012bmes, punkti, koli vai pasv\u012btras.",
    "Image is decorative": "Att\u0113ls ir dekorat\u012bvs",
    "Image list": "Att\u0113lu saraksts",
    "Image title": "Att\u0113la virsraksts",
    "Image...": "Att\u0113ls...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP k\u013c\u016bda: nevar\u0113ja atrast att\u0113la starpniekserveri",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP k\u013c\u016bda: nepareizs att\u0113la starpniekservera URL",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP error: Noraid\u012bts piepras\u012bjums",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP k\u013c\u016bda: nezin\u0101ma ImageProxy k\u013c\u016bda",
    "Increase indent": "Palielin\u0101t atk\u0101pi",
    "Inline": "Inline elementi",
    "Insert": "Ievietot",
    "Insert Template": "Ievietot \u0160ablonu",
    "Insert accordion": "Ievietot akordeonu",
    "Insert column after": "Jauna sleja pa labi",
    "Insert column before": "Jauna sleja pa kreisi",
    "Insert date/time": "Ievietot datumu/laiku",
    "Insert image": "Ievietot att\u0113lu",
    "Insert link (if link plugin activated)": "Ievietot saiti (Ja sai\u0161u spraudnis ir akt\u012bvs)",
    "Insert row after": "Jauna rinda zem\u0101k",
    "Insert row before": "Jauna rinda augst\u0101k",
    "Insert table": "Ievietot tabulu",
    "Insert template...": "Ievietot \u0161ablonu...",
    "Insert video": "Ievietot video",
    "Insert/Edit code sample": "Ievad\u012bt/Labot koda paraugu",
    "Insert/edit image": "Ievietot/labot att\u0113lu",
    "Insert/edit link": "Ievietot/labot saiti",
    "Insert/edit media": "Ievietot/labot att\u0113lu",
    "Insert/edit video": "Ievietot/redi\u0123\u0113t video",
    "Inset": "Iek\u0161\u0113js",
    "Invalid hex color code: {0}": "Neder\u012bgs kr\u0101sas hex kods {0}",
    "Invalid input": "Neder\u012bga ievade",
    "Italic": "Sl\u012bpraksts",
    "Justify": "Izl\u012bdzin\u0101t",
    "Keyboard Navigation": "Klaviat\u016bras Navig\u0101cija",
    "Language": "Valoda",
    "Learn more...": "Uzzin\u0101t vair\u0101k...",
    "Left": "Pa kreisi",
    "Left to right": "No kreis\u0101s uz labo",
    "Light Blue": "Gai\u0161i Zils",
    "Light Gray": "Gai\u0161i Pel\u0113ks",
    "Light Green": "Gai\u0161i Za\u013c\u0161",
    "Light Purple": "Gai\u0161i Violets",
    "Light Red": "Gai\u0161i Sarkans",
    "Light Yellow": "Gai\u0161i Dzeltens",
    "Line height": "L\u012bnijas augstums",
    "Link list": "Sai\u0161u saraksts",
    "Link...": "Saite...",
    "List Properties": "Saraksta \u012apa\u0161\u012bbas",
    "List properties...": "Saraksta \u012bpa\u0161\u012bbas...",
    "Loading emojis...": "Notiek emoz\u012bmju iel\u0101de...",
    "Loading...": "Iel\u0101d\u0113...",
    "Lower Alpha": "Lat\u012b\u0146u mazie burti",
    "Lower Greek": "Grie\u0137u mazie burti",
    "Lower Roman": "Romie\u0161u mazie burti",
    "Match case": "At\u0161\u0137irt lielos un mazos burtus",
    "Mathematical": "Matem\u0101tisks",
    "Media poster (Image URL)": "Mediju afi\u0161a (Att\u0113la URL)",
    "Media...": "Mediju...",
    "Medium Blue": "Vid\u0113ji zils",
    "Medium Gray": "Vid\u0113ji Pel\u0113ks",
    "Medium Purple": "Vid\u0113ji violets",
    "Merge cells": "Apvienot \u0161\u016bnas",
    "Middle": "Pa vidu",
    "Midnight Blue": "Puznakts Zils",
    "More...": "Vair\u0101k...",
    "Name": "Nosaukums",
    "Navy Blue": "J\u016bras zils",
    "New document": "Jauns dokuments",
    "New window": "Jaun\u0101 \u0161\u0137irkl\u012b",
    "Next": "N\u0101kamais",
    "No": "N\u0113",
    "No alignment": "Bez izl\u012bdzin\u0101\u0161anas",
    "No color": "Nenor\u0101d\u012bt kr\u0101su",
    "Nonbreaking space": "Nedal\u0101m\u0101 atstarpe",
    "None": "\u2014",
    "Numbered list": "Numur\u0113ts saraksts",
    "OR": "VAI",
    "Objects": "Objekti",
    "Ok": "Ok",
    "Open help dialog": "Atv\u0113rt pal\u012bdz\u012bbas dialogu",
    "Open link": "Atv\u0113rt saiti",
    "Open link in...": "Atv\u0113rt saiti...",
    "Open popup menu for split buttons": "Atv\u0113rt uzleco\u0161o izv\u0113lni dal\u012btaj\u0101m pog\u0101m",
    "Orange": "Oran\u017es",
    "Outset": "\u0100r\u0113js",
    "Page break": "P\u0101reja uz jauno lapu",
    "Paragraph": "Rindkopa",
    "Paste": "Iel\u012bm\u0113t",
    "Paste as text": "Iel\u012bm\u0113t bez format\u0113juma",
    "Paste column after": "Ievietot p\u0113c slejas",
    "Paste column before": "Ievietot pirms slejas",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Iel\u012bm\u0113\u0161ana vienk\u0101r\u0161\u0101 teksta re\u017e\u012bm\u0101. Saturs tiks iel\u012bm\u0113ts bez format\u0113juma l\u012bdz \u0161\u012b opcija tiks atsl\u0113gta.",
    "Paste or type a link": "Iekop\u0113jiet vai ierakstiet saiti",
    "Paste row after": "Iel\u012bm\u0113t rindu zem\u0101k",
    "Paste row before": "Iel\u012bm\u0113t rindu augst\u0101k",
    "Paste your embed code below:": "Iekop\u0113jiet Embed kodu \u0161eit:",
    "People": "Cilv\u0113ki",
    "Plugins": "Spraud\u0146i",
    "Plugins installed ({0}):": "Spraud\u0146i instal\u0113ti ({0}):",
    "Powered by {0}": "Darb\u012bbu nodro\u0161ina {0}",
    "Pre": "Pre",
    "Preferences": "Iestat\u012bjumi",
    "Preformatted": "Ieprieks format\u0113ts",
    "Premium plugins:": "\u012apa\u0161ie spraud\u0146i:",
    "Press the Up and Down arrow keys to resize the editor.": "Nospiediet bulti\u0146u uz aug\u0161u un uz leju, lai main\u012btu redaktora lielumu.",
    "Press the arrow keys to resize the editor.": "Nospiediet bulti\u0146u, lai main\u012btu redaktora lielumu.",
    "Press {0} for help": "Lai sa\u0146emtu pal\u012bdz\u012bbu, nospiediet {0}",
    "Preview": "Priek\u0161skat\u012bt",
    "Previous": "Iepriek\u0161\u0113jais",
    "Print": "Druk\u0101t",
    "Print...": "Druk\u0101t...",
    "Purple": "Violets",
    "Quotations": "Cit\u0101ti",
    "R": "S",
    "Range 0 to 255": "Diapazons 0 l\u012bdz 255",
    "Red": "Sarkans",
    "Red component": "Sarkanais komonents",
    "Redo": "Atcelt darb\u012bbu",
    "Remove": "No\u0146emt",
    "Remove color": "No\u0146emt kr\u0101su",
    "Remove link": "No\u0146emt saiti",
    "Replace": "Aizvietot",
    "Replace all": "Aizvietot visu",
    "Replace with": "Aizvietot ar",
    "Resize": "Main\u012bt izm\u0113ru",
    "Restore last draft": "Atjaunot p\u0113d\u0113jo melnrakstu",
    "Reveal or hide additional toolbar items": "Par\u0101d\u012bt vai pasl\u0113piet papildu r\u012bkjoslas vienumus",
    "Rich Text Area": "Satura redaktors",
    "Rich Text Area. Press ALT-0 for help.": "Satura redaktors. Piespiediet ALT-0, lai atv\u0113rtu pal\u012bdz\u012bbu.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Satura redaktors. Nospiediet ALT-F9 lai atv\u0113rtu izv\u0113lni. Nospiediet ALT-F10, lai atv\u0113rtu r\u012bkjoslu vai ALT-0 pal\u012bdz\u012bbai",
    "Ridge": "Gr\u0113da",
    "Right": "Pa labi",
    "Right to left": "No lab\u0101s uz kreiso",
    "Row": "Rinda",
    "Row clipboard actions": "Rindas starpliktuves darb\u012bba",
    "Row group": "Rindu grupa",
    "Row header": "Galvenes rinda",
    "Row properties": "Rindas parametri",
    "Row type": "Rindas veids",
    "Rows": "Rindas",
    "Save": "Saglab\u0101t",
    "Save (if save plugin activated)": "Saglab\u0101t (Ja saglab\u0101\u0161anas spraudnis ir akt\u012bvs)",
    "Scope": "Attiecin\u0101t uz",
    "Search": "Mekl\u0113t",
    "Select all": "Izv\u0113l\u0113ties visu",
    "Select...": "Izv\u0113lies...",
    "Selection": "Atlase",
    "Shortcut": "Sa\u012bsne",
    "Show blocks": "R\u0101d\u012bt blokus",
    "Show caption": "R\u0101d\u012bt parakstu",
    "Show invisible characters": "R\u0101d\u012bt neredzam\u0101s rakstz\u012bmes",
    "Size": "Izm\u0113rs",
    "Solid": "Mas\u012bvs",
    "Source": "Avots",
    "Source code": "Pirmkods",
    "Special Character": "Specialais simbols",
    "Special character...": "Specialais simbols...",
    "Split cell": "Sadal\u012bt \u0161\u016bnas",
    "Square": "Kvadr\u0101ts",
    "Start list at number": "S\u0101kt sarakstu ar skaitli",
    "Strikethrough": "P\u0101rsv\u012btrot",
    "Style": "Stils",
    "Subscript": "Apak\u0161raksts",
    "Superscript": "Aug\u0161raksts",
    "Switch to or from fullscreen mode": "P\u0101rsl\u0113gties uz/no pilnekr\u0101na re\u017e\u012bmu",
    "Symbols": "Simboli",
    "System Font": "Sist\u0113mas fonts",
    "Table": "Tabula",
    "Table caption": "Tabulas paraksts",
    "Table properties": "Tabulas parametri",
    "Table styles": "Tabulas stils",
    "Template": "Veidne",
    "Templates": "Veidnes",
    "Text": "Teksts",
    "Text color": "Teksta kr\u0101sa",
    "Text color {0}": "Teksta kr\u0101sa {0}",
    "Text to display": "Nosaukums",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": 'J\u016bs ievad\u012bj\u0101t e-pasta adresi. Lai t\u0101 korekti darbotos, ir nepiecie\u0161ams to papildin\u0101t ar "mailto:" priek\u0161\u0101. Vai v\u0113laties to izdar\u012bt?',
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": 'J\u016bs ievad\u012bj\u0101t \u0101r\u0113jo saiti. Lai t\u0101 korekti darbotos, ir nepiecie\u0161ams to papildin\u0101t ar "http://" priek\u0161\u0101. Vai v\u0113laties to izdar\u012bt?',
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Ievietot\u0101 URL saite ir no \u0101r\u0113ja avota. Vai v\u0113laties pievienot nepiecie\u0161amo https://?",
    "Title": "Nosaukums",
    "To open the popup, press Shift+Enter": "Lai atv\u0113rtu uzleco\u0161o logu, nospied Shift+Enter",
    "Toggle accordion": "P\u0101rsl\u0113gt akordeonu",
    "Tools": "R\u012bki",
    "Top": "Aug\u0161\u0101",
    "Travel and Places": "Ce\u013co\u0161ana un Vietas",
    "Turquoise": "Tirk\u012bzs",
    "Underline": "Pasv\u012btrot",
    "Undo": "Atsaukt",
    "Upload": "Aug\u0161upiel\u0101d\u0113t",
    "Uploading image": "Aug\u0161upielade att\u0113lu",
    "Upper Alpha": "Lat\u012b\u0146u lielie burti",
    "Upper Roman": "Romie\u0161u lielie burti",
    "Url": "Adrese",
    "User Defined": "Lietot\u0101ja defin\u0113ts",
    "Valid": "Der\u012bgs(-i)",
    "Version": "Versija",
    "Vertical align": "Vertik\u0101la izl\u012bdzin\u0101\u0161ana",
    "Vertical space": "Vertik\u0101l\u0101 atstarpe",
    "View": "Skat\u012bt",
    "Visual aids": "Vizu\u0101l\u0101 pal\u012bdz\u012bba",
    "Warn": "Br\u012bdin\u0101jums",
    "White": "Balts",
    "Width": "Platums",
    "Word count": "V\u0101rdu skaits",
    "Words": "V\u0101rdi",
    "Words: {0}": "V\u0101rdi: {0}",
    "Yellow": "Dzeltens",
    "Yes": "J\u0101",
    "You are using {0}": "J\u016bs lietojiet {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Saturs ir labots un nav saglab\u0101ts. Vai tie\u0161\u0101m v\u0113laties atst\u0101t \u0161o lapu?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "J\u016bsu p\u0101rl\u016bkprogramma neatbalsta piek\u013cuvi starpliktuvei. L\u016bdzu, lietojiet Ctrl+X/C/V klaviat\u016bras sa\u012bsnes.",
    "alignment": "izl\u012bdzin\u0101\u0161ana",
    "austral sign": "",
    "cedi sign": "",
    "colon sign": "kolona z\u012bme",
    "cruzeiro sign": "kruzeiro z\u012bme",
    "currency sign": "val\u016btas z\u012bme",
    "dollar sign": "dol\u0101ra z\u012bme",
    "dong sign": "",
    "drachma sign": "drahmas z\u012bme",
    "euro-currency sign": "eiro val\u016btas z\u012bme",
    "example": "piem\u0113rs",
    "formatting": "format\u0113jums",
    "french franc sign": "fran\u010du franka z\u012bme",
    "german penny symbol": "",
    "guarani sign": "",
    "history": "v\u0113sture",
    "hryvnia sign": "grivna z\u012bme",
    "indentation": "atk\u0101pes",
    "indian rupee sign": "",
    "kip sign": "",
    "lira sign": "liras z\u012bme",
    "livre tournois sign": "",
    "manat sign": "",
    "mill sign": "",
    "naira sign": "",
    "new sheqel sign": "",
    "nordic mark sign": "",
    "peseta sign": "",
    "peso sign": "peso z\u012bme",
    "ruble sign": "rub\u013ca z\u012bme",
    "rupee sign": "r\u016bpija z\u012bme",
    "spesmilo sign": "",
    "styles": "stili",
    "tenge sign": "",
    "tugrik sign": "",
    "turkish lira sign": "turku liras z\u012bme",
    "won sign": "",
    "yen character": "jenas z\u012bme",
    "yen/yuan character variant one": "jua\u0146u z\u012bmes pirmais variants",
    "yuan character": "jua\u0146as z\u012bme",
    "yuan character, in hong kong and taiwan": "jua\u0146as z\u012bme Hongkong\u0101 un Taiv\u0101n\u0101",
    "{0} characters": "{0} simboli",
    "{0} columns, {1} rows": "{0} kolonnas, {1} rindas",
    "{0} words": "{0} v\u0101rdi"
});